import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import './NewProject.css';
import Input from 'components/shared/input/Input';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import CheckBox from 'components/shared/checkbox/CheckBox';
import LabeledCheckBox from 'components/shared/checkbox/LabeledCheckBox';
import {
  loadClientsRequest,
  loadClientsSuccess,
} from 'actions/admin/clients/clients';
import {
  getClients,
  getClientsCurrentPage,
  getClientsPageSize,
  getClientsTotal,
} from 'selectors/admin/clients/clients';
import {
  getProjectForm,
  getShowNewClientModal,
} from 'components/admin/projects/creation/store/selectors';
import {
  setProjectFormValue,
  nextStage,
  setShowNewClientModal,
} from 'components/admin/projects/creation/store/actions';
import NewClientModal from 'components/admin/projects/creation/NewClientModal';
import numeral from 'numeral';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';

class ClientSelection extends Component {
  componentDidMount() {
    this.props.dispatch(loadClientsRequest(1));
  }

  handleProjectFormChange = (attribute, value) => {
    this.props.dispatch(setProjectFormValue(attribute, value));
  };

  handleClientSelection = (value) => {
    if (value !== this.props.projectForm.clientId) {
      this.props.dispatch(setProjectFormValue('clientId', value));
      this.props.dispatch(setProjectFormValue('buildingId', null));
    }
  };

  handleContinue = () => {
    this.props.dispatch(nextStage());
  };

  showAddNewClientModal = () => {
    this.props.dispatch(setShowNewClientModal(true));
  };

  handleClientsPageChange = (newPage) => {
    this.props.dispatch(loadClientsSuccess([]));
    this.props.dispatch(loadClientsRequest(newPage));
  };

  advancedDocumentCheckbox = () => {
    const { currentProject } = this.props;
    if (currentProject && currentProject.documents_count === 0) {
      return (
        <Row>
          <Col md={4}>
            <LabeledCheckBox
              checked={this.props.projectForm.advancedDocumentView}
              size="medium"
              label="Enable Advanced Document View"
              onChange={(value) =>
                this.handleProjectFormChange('advancedDocumentView', value)
              }
            />
          </Col>
        </Row>
      );
    }
  };

  render() {
    return (
      <div>
        <h3 className="selection-title">Project Details</h3>

        <div className="details-form">
          <Row>
            <Col md={4}>
              <Input
                placeholder="Project Number"
                value={this.props.projectForm.number}
                onChange={this.handleProjectFormChange.bind(this, 'number')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Input
                placeholder="Project Name"
                value={this.props.projectForm.name}
                onChange={this.handleProjectFormChange.bind(this, 'name')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Input
                placeholder="Approx. Square Feet"
                value={
                  this.props.projectForm.sqFootage
                    ? numeral(this.props.projectForm.sqFootage).format('0,0')
                    : ''
                }
                onChange={(value) =>
                  this.handleProjectFormChange(
                    'sqFootage',
                    numeral(value).value()
                  )
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <DatetimePicker
                format="MM/DD/YY"
                isValidDate={todayValidation}
                placeholder="Bid Due Date"
                value={this.props.projectForm.bidDueDate}
                onChange={(value) =>
                  this.handleProjectFormChange('bidDueDate', value)
                }
              />
            </Col>
          </Row>
          {this.advancedDocumentCheckbox()}
        </div>

        <hr />

        <div>
          <h3 className="selection-title">Which client is the Project for?</h3>
          <input
            className={`btn button button-orange add-new-client-button`}
            type="button"
            value="Add New Client"
            onClick={this.showAddNewClientModal}
          />
        </div>

        <div className="selection-table-container">
          <SimpleTable
            headers={['', 'COMPANY NAME', 'CONTACT']}
            rows={this.mapClients(this.props.clients)}
            emptyMessage="No Clients"
          />
        </div>

        <div className="pagination-container">
          <SimplePagination
            currentPage={this.props.clientsCurrentPage}
            pageSize={this.props.clientsPageSize}
            total={this.props.clientsTotal}
            onPageChange={this.handleClientsPageChange}
          />
        </div>

        {this.props.showNewClientModal && <NewClientModal />}

        <input
          className={`btn button button-continue ${
            this.canContinue() ? 'button-orange' : 'button-disabled'
          }`}
          type="button"
          value="Continue"
          onClick={this.handleContinue}
          disabled={!this.canContinue()}
        />
      </div>
    );
  }

  mapClients = (clients) => {
    return clients.map((client) => {
      return [
        <CheckBox
          id={client.id}
          checked={client.id === this.props.projectForm.clientId}
          shape={'round'}
          size={'medium'}
          onChange={this.handleClientSelection.bind(this)}
        />,
        <span className="h4">{client.company_name}</span>,
        `${client.contact.first_name} ${client.contact.last_name}`,
      ];
    });
  };

  canContinue = () => {
    return (
      !!this.props.projectForm.number &&
      !!this.props.projectForm.name &&
      !!this.props.projectForm.sqFootage &&
      !!this.props.projectForm.clientId &&
      !!this.props.projectForm.bidDueDate
    );
  };
}

export default connect((state) => {
  return {
    clients: getClients(state),
    clientsCurrentPage: getClientsCurrentPage(state),
    clientsPageSize: getClientsPageSize(state),
    clientsTotal: getClientsTotal(state),
    projectForm: getProjectForm(state),
    showNewClientModal: getShowNewClientModal(state),
    currentProject: getCurrentProject(state),
  };
})(ClientSelection);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/ClientSelection.js